import { MapPin } from "lucide-react";
import { GEOFENCE_PRIVACY_NOTICE } from "@crewledger/shared/geofence";
import { PageHeader } from "@/components/design";

/** Placeholder for future employee clock-in/out — shares geofence validation with daily entry. */
export function FieldClockPage() {
  return (
    <div className="mx-auto max-w-lg space-y-6">
      <PageHeader
        title="Field clock"
        description="Worker clock-in and clock-out from the job site — coming soon."
      />
      <div className="rounded-xl border bg-card-white p-6 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-navy-blueprint/10 text-navy-blueprint">
          <MapPin className="h-7 w-7" />
        </div>
        <p className="text-sm text-muted-foreground">
          This page will let crew members clock in and out with the same geofence checks used for
          manager daily entry.
        </p>
        <p className="mt-4 text-xs text-muted-foreground">{GEOFENCE_PRIVACY_NOTICE}</p>
      </div>
    </div>
  );
}
